module.exports = __webpack_public_path__ + "img/d8c82e32-37df-4add-b4e1-021a40368f90.a69290fd.png";